<template>
  <div class="parctical-unit">
    <div v-if="managerList.length === 0" class="alignment">
      <div class="nodata">
      <img style="padding-top: 4.1rem;width: 6.47rem;height: 6.47rem;" src="@/assets/image/index/暂无数据@2x.png" />
      <span class="nodata-text ">暂无数据</span>
      </div>
    </div>
    <div v-for="item in managerList">
        <div class="card mb-16" >
          <div class="card-img-box">
            <img class="card-img"  :src="item.avatar" />
          </div>
          <div class="card-content">
            <div class="card-title">{{item.postList?item.postList:'-'}}</div>
            <div class="card-text">{{ item.nickName? item.nickName:'-'}}&nbsp;/&nbsp;{{formatPhoneNumber(item.phoneNumber)}}</div>
          </div>
      </div>
      <el-divider></el-divider>
    </div>

  </div>
</template>
<script >
import { getProjectManager } from '@/utils/indexApi';
export default{
  data(){
    return{
      managerList:[]
    }
  },
  methods:{
    getList(){
      getProjectManager().then(res=>{
        this.managerList = res.data
      })
    },
    formatPhoneNumber(phoneNumber) {
      return phoneNumber.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1 $2 $3');
    }
  },
  created(){
    this.getList()
  }
}
</script>
<style lang="scss" scoped>
.alignment{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.parctical-unit{
  height: 100%;
}
.nodata {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;

}
.mt-16{
  margin-top: 16px;
}
.mb-16{
  margin-bottom: 16px;
}
.el-divider{
  background: #BBC6D6;
  opacity: 0.3;
}
.card{
  width: 370px;
  height: 90px;
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #27507D;
  box-shadow: inset 0px 1px 6px 0px rgba(81,216,255,0.5);
  border-radius: 8px;
  backdrop-filter: blur(5px);
  overflow: hidden;
  .card-img-box{
    width: 66px;
    height: 66px;
    border-radius: 8px;
    border: 2px solid #547FB3;
    overflow: hidden;
  }
  .card-img{
    width: 100%;
    height: 100%;

  }

  .card-content{
    .card-title{
      width: 270px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-wrap: nowrap;
      overflow: hidden;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 17px;
      color: #FFA83B;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
    .card-text{
      width: 270px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-wrap: nowrap;
      margin-top: 18px;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }
}
</style>
